import React from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { FeatureStrip } from "@/components/site/FeatureStrip";
import { About } from "@/components/site/About";
import { EventsSection } from "@/components/site/EventsSection";
import { VenueSpaces } from "@/components/site/VenueSpaces";
import { Gallery } from "@/components/site/Gallery";
import { BookingForm } from "@/components/site/BookingForm";
import { Testimonials } from "@/components/site/Testimonials";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-epic-black min-h-screen">
      <Navbar />
      <Hero />
      <FeatureStrip />
      <About />
      <EventsSection />
      <VenueSpaces />
      <Gallery />
      <BookingForm />
      <Testimonials />
      <Footer />
    </div>
  );
}
